import { motion, AnimatePresence } from "framer-motion";

const Loader = ({ isLoading }) => {
    return (
        <AnimatePresence>
            {isLoading && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{
                        opacity: 0,
                        backdropFilter: "blur(0px)", // El desenfoque también se desvanece
                        transition: { duration: 0.8, ease: "circOut" }
                    }}
                    // bg-black/40: Fondo muy transparente
                    // backdrop-blur-xl: Desenfoque profundo para mantener legibilidad
                    className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black/40 backdrop-blur-xl"
                >
                    <div className="relative">

                        {/* TEXTO CON ESCÁNER LÁSER */}
                        <div className="relative overflow-hidden px-6 py-2">
                            <h1 className="text-6xl md:text-8xl font-black text-white tracking-tighter select-none drop-shadow-2xl">
                                PLA<span className="text-[#F26B1D]">NIX</span>
                            </h1>

                            {/* LÍNEA DE ESCÁNER (Barrido de luz) */}
                            <motion.div
                                initial={{ x: "-150%" }}
                                animate={{ x: "150%" }}
                                transition={{
                                    repeat: Infinity,
                                    duration: 2.5,
                                    ease: "linear"
                                }}
                                className="absolute inset-y-0 w-40 bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 z-10"
                            />
                        </div>

                        {/* BARRA DE CARGA MINIMALISTA */}
                        <div className="mt-2 w-full h-[1px] bg-white/20 rounded-full overflow-hidden relative">
                            <motion.div
                                initial={{ width: "0%" }}
                                animate={{ width: "100%" }}
                                transition={{ duration: 2.5, ease: "easeInOut" }}
                                className="absolute inset-y-0 left-0 bg-[#F26B1D] shadow-[0_0_15px_#F26B1D]"
                            />
                        </div>

                        {/* ESTADO DEL SISTEMA */}
                        <div className="mt-8 flex flex-col items-center">
                            <motion.span
                                animate={{ opacity: [0.3, 1, 0.3] }}
                                transition={{ repeat: Infinity, duration: 1.5 }}
                                className="text-[8px] text-white/60 font-black uppercase tracking-[0.8em]"
                            >
                                Digitalizing Property
                            </motion.span>
                        </div>
                    </div>

                    {/* DETALLES TÉCNICOS EN LAS ESQUINAS */}
                    <div className="absolute top-10 left-10 w-8 h-8 border-t border-l border-white/30" />
                    <div className="absolute bottom-10 right-10 w-8 h-8 border-b border-r border-white/30" />

                    {/* COORDENADAS SIMULADAS (Estilo Topográfico) */}
                    <div className="absolute bottom-10 left-10 text-[8px] text-white/20 font-mono space-y-1 hidden md:block">
                        <p>LAT: 12.0464° S</p>
                        <p>LON: 77.0428° W</p>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Loader;